import { VoucherFilterInput } from "@saleor/types/globalTypes";

import { VoucherListUrlFilters } from "../../urls";

export function getFilterVariables(
  params: VoucherListUrlFilters
): VoucherFilterInput {
  return {
    search: params.query
  };
}
